import {combineReducers} from 'redux';

import tabletCellBundles from './tablet-cell-bundless';

export default combineReducers({
    tabletCellBundles,
});
